import { createFileRoute } from '@tanstack/react-router';
import { CashPage } from '@/features/checkout/pages/cash-page';

export const Route = createFileRoute('/_app/cash')({ component: CashPage });
